// @flow
import LayoutHintCollection from "../layouthint/LayoutHintCollection";

import createAttribute from "../attributes/_createAttribute";
import { ATTRIBUTE_WIDTH } from "../../constants";

import type SortingModel from "../sorting/SortingModel";
import type SortOptionModel from "../sorting/SortOptionModel";

/**
 * One header item of the list
 */
export default class ListHeaderModel {
  _key: string;
  _header: {
    label: string,
    type: string,
    layouthint: Array<string>,
  };
  _sortOption: ?SortOptionModel;
  _readonlyWidth: $Keys<typeof ATTRIBUTE_WIDTH>;

  /**
   * constructor
   */
  constructor(header: Object, sorting?: SortingModel) {
    const [headerKey] = Object.keys(header);

    const attribute = createAttribute(headerKey, {}, header[headerKey]);
    this._readonlyWidth = attribute.readonlyWidth;
    this._key = headerKey;
    this._header = header[headerKey];
    this._sortOption =
      sorting && sorting.find((sortOption) => sortOption.key === headerKey);
  }

  /**
   * Get key
   */
  get key(): string {
    return this._key;
  }

  /**
   * Getting the label of this header item
   */
  get label(): string {
    return this._header.label;
  }

  /**
   * Getting the type of this header item. For instance string, date, etc.
   */
  get type(): string {
    return this._header.type;
  }

  /**
   * Getting the layout hints of this header item
   */
  get layouthint(): LayoutHintCollection {
    return new LayoutHintCollection(this._header.layouthint || []);
  }

  /**
   * Get alignment of header label
   */
  get alignment(): string {
    const alignment = this.layouthint.getByLayoutHint("align-");
    return alignment === null ? "left" : alignment.substring("align-".length);
  }

  /**
   */
  get readonlyWidth(): $Keys<typeof ATTRIBUTE_WIDTH> {
    return this._readonlyWidth ?? ATTRIBUTE_WIDTH.MEDIUM;
  }

  /**
   */
  equals(listHeader: ListHeaderModel): boolean {
    return listHeader.key === this.key;
  }

  /**
   */
  get sortOption(): ?SortOptionModel {
    return this._sortOption;
  }

  /**
   */
  hasSorting(): boolean {
    return this.sortOption != null;
  }
}
